import { render, staticRenderFns } from "./HistoryInvoicesTab.vue?vue&type=template&id=88243088&scoped=true"
import script from "./HistoryInvoicesTab.vue?vue&type=script&lang=js"
export * from "./HistoryInvoicesTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryInvoicesTab.vue?vue&type=style&index=0&id=88243088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88243088",
  null
  
)

export default component.exports